import { useState } from 'react'
import { useSelector } from 'react-redux'
import { FilterSection } from '../FilterSection'
import { RoomCountRadio } from './RoomCountRadio'
import { defineMessages, useIntl } from 'react-intl'
import { selectFilter } from '../../../../store/selectors/filters'

import styles from './Rooms.module.scss'

export const MSG = defineMessages({
  any: {
    id: 'HomeSearch.listings.filters.radio.any',
    defaultMessage: 'Any',
  },
  one: {
    id: 'HomeSearch.listings.filters.radio.1',
    defaultMessage: '1+',
  },
  two: {
    id: 'HomeSearch.listings.filters.radio.2',
    defaultMessage: '2+',
  },
  three: {
    id: 'HomeSearch.listings.filters.radio.3',
    defaultMessage: '3+',
  },
  four: {
    id: 'HomeSearch.listings.filters.radio.4',
    defaultMessage: '4+',
  },
  five: {
    id: 'HomeSearch.listings.filters.radio.5',
    defaultMessage: '5+',
  },
})

export interface RoomsProps {
  name: string
  title: string
}

export const Rooms = ({ name, title }: RoomsProps) => {
  const intl = useIntl()
  const filters = useSelector(selectFilter)
  const [roomCount, setRoomCount] = useState(filters[name])

  return (
    <FilterSection title={title}>
      <fieldset className={styles.radioFields}>
        <RoomCountRadio
          name={name}
          isChecked={!roomCount}
          onChange={() => setRoomCount(null)}
          label={intl.formatMessage(MSG.any)}
        />
        <RoomCountRadio
          value={1}
          name={name}
          isChecked={roomCount === 1}
          onChange={() => setRoomCount(1)}
          label={intl.formatMessage(MSG.one)}
        />
        <RoomCountRadio
          value={2}
          name={name}
          isChecked={roomCount === 2}
          onChange={() => setRoomCount(2)}
          label={intl.formatMessage(MSG.two)}
        />
        <RoomCountRadio
          value={3}
          name={name}
          isChecked={roomCount === 3}
          onChange={() => setRoomCount(3)}
          label={intl.formatMessage(MSG.three)}
        />
        <RoomCountRadio
          value={4}
          name={name}
          isChecked={roomCount === 4}
          onChange={() => setRoomCount(4)}
          label={intl.formatMessage(MSG.four)}
        />
        <RoomCountRadio
          value={5}
          name={name}
          isChecked={roomCount === 5}
          onChange={() => setRoomCount(5)}
          label={intl.formatMessage(MSG.five)}
        />
      </fieldset>
    </FilterSection>
  )
}
